export const COLORS = {
  border: '#E5E7EB',
  text: {
    primary: '#111827',
    secondary: '#374151',
    muted: '#6B7280',
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#F8F9FA',
    hover: '#F9FAFB',
  },
  progress: '#06B6D4',
} as const;

export const metricBoxStyles = {
  container: {
    textAlign: 'right',
    minWidth: '60px',
  },
  label: {
    color: COLORS.text.muted,
    fontSize: '16px',
    fontWeight: 400,
    marginBottom: '2px',
    fontFamily: 'Inter, sans-serif',
  },
  value: {
    fontWeight: 500,
    color: COLORS.text.primary,
    fontSize: '14px',
    lineHeight: 1.2,
    fontFamily: 'Inter, sans-serif',
  },
};

export const periodSelectorStyles = {
  periodContainer: {
    padding: '16px 24px',
    backgroundColor: '#F5F6FA',
    borderRadius: '8px 8px 0 0',
    borderBottom: `1px solid ${COLORS.border}`,
  },
  periodLabel: {
    color: '#7E8796',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter, sans-serif',
  },
  periodSelect: {
    backgroundColor: COLORS.background.primary,
    minWidth: 180,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.border,
      borderRadius: '6px',
    },
    '& .MuiSelect-select': {
      padding: '8px 12px',
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'Inter, sans-serif',
    },
  },
};

export const usageDataTableStyles = {
  table: {
    width: '100%',
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${COLORS.border}`,
      padding: '12px 16px',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none',
    },
    '& .MuiTableHead-root': {
      '& .MuiTableCell-root': {
        borderBottom: `1px solid ${COLORS.border}`,
      },
    },
  },
  tableHeader: {
    fontWeight: 300,
    color: '#7E8796',
    fontSize: '16px',
    height: '50px',
    backgroundColor: '#F5F6FA',
    borderBottom: `1px solid ${COLORS.border}`,
    fontFamily: 'Inter, sans-serif',
  },
  tableHeaderFirst: {
    borderTopLeftRadius: '8px',
  },
  tableHeaderLast: {
    borderTopRightRadius: '8px',
  },
  tableCell: {
    fontSize: '16px',
    color: COLORS.text.primary,
    fontWeight: 400,
    fontFamily: 'Inter, sans-serif',
  },
  tableCellAmount: {
    fontSize: '16px',
    color: COLORS.text.primary,
    fontWeight: 500,
    fontFamily: 'Inter, sans-serif',
  },
  tableRow: {
    '&:hover': { backgroundColor: COLORS.background.hover },
  },
  verticalDivider: {
    borderRight: `1px solid ${COLORS.border}`,
  },
};

export const usageItemAccordionStyles = {
  accordion: {
    boxShadow: 'none',
    '&:before': { display: 'none' },
    border: `1px solid ${COLORS.border}`,
    borderRadius: '12px !important',
    backgroundColor: COLORS.background.primary,
  },
};

export const lineItemActionStyles = {
  actionsContainer: {
    gap: '16px',
  },
  metricsContainer: {
    gap: '56px',
  },
};

export const lineItemHeaderStyles = {
  container: {
    maxWidth: '222px',
  },
  title: {
    fontWeight: 400,
    color: COLORS.text.primary,
    fontSize: '16px',
    lineHeight: 1.2,
    fontFamily: 'Inter, sans-serif',
  },
  description: {
    color: COLORS.text.muted,
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
  },
  percentage: {
    color: COLORS.text.muted,
    fontSize: '16px',
    fontFamily: 'Inter, sans-serif',
  },
};

export const usageItemSummaryStyles = {
  accordionSummary: {
    padding: '16px 24px',
    flexDirection: 'row-reverse',
    minHeight: '56px',
    '& .MuiAccordionSummary-content': {
      margin: 0,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: '8px',
      marginLeft: 0,
      color: COLORS.text.muted,
    },
  },
  accordionTitle: {
    fontWeight: 400,
    minWidth: '240px',
    color: COLORS.text.primary,
    fontSize: '16px',
    lineHeight: 1.2,
    fontFamily: 'Inter, sans-serif',
  },
  progressText: {
    color: COLORS.text.secondary,
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
    width: '100%',
  },
  progressContainer: {
    maxWidth: 240,
  },
  overageStatus: {
    display: 'inline-flex',
    alignItems: 'center',
    columnGap: '8px',
    marginLeft: 4,
    whiteSpace: 'nowrap',
    backgroundColor: '#FDE7EF',
    color: '#E81B73',
    paddingRight: 12,
    fontFamily: 'Inter, sans-serif',
  },
  overageIcon: {
    transform: 'scale(0.8)',
  },
};
